import * as React from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import { useNavigate } from 'react-router-dom';
import { IconButton } from 'uiKit/atoms/IconButton/IconButton';
import { Menu } from 'uiKit/atoms/Menu/Menu';
import { MenuItem } from 'uiKit/atoms/MenuItem/MenuItem';
import { MoreVert } from 'uiKit/atoms/MoreVert/MoreVert';
import { Divider } from 'uiKit/atoms/Divider/Divider';
import styles from './MyCharityBanners.module.scss';
import { useStores } from 'stores';

interface DottedMenuProps {
  bannerId: string;
}

const options = ['Edit', 'Delete'];

const ITEM_HEIGHT = 48;

const DottedMenu: React.FC<DottedMenuProps> = ({ bannerId }) => {
  const { 
    charityBannerStore: { deleteBanner }
    } = useStores();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = async (option: string) => {
    if (option === 'Edit') {
      navigate(`/edit-banner/${bannerId}`);
    } else if (option === 'Delete') {
      try {
        await deleteBanner(bannerId);
      } catch (error) {
        console.error('Error deleting banner:', error);
      }
    }
    handleClose();
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVert style={{ color: '#707D80' }} />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
          },
        }}
      >
        {options.map((option, index) => (
          <div key={option}>
            <MenuItem
              onClick={() => handleOptionClick(option)}
              sx={{ color: option === 'Delete' ? '#f87562 !important' : 'inherit' }}
              className={styles.dropdown_item}
            >
              {option}
            </MenuItem>
            {index < options.length - 1 && <Divider />}
          </div>
        ))}
      </Menu>
    </div>
  );
};

DottedMenu.propTypes = {
  bannerId: PropTypes.string.isRequired,
};

export default DottedMenu;
